(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blue-lagoon-addons"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const configElement = document.getElementById('BlueLagoonAddonsConfig');
    const template = document.getElementById('BlueLagoonAddonsPresentation');
    const root = document.getElementById('MainContent');
    if (!configElement || !template || !root || configElement.dataset.initialized) return;
    configElement.dataset.initialized = 'true';
    const config = JSON.parse(configElement.textContent);
    const money = cents => new Intl.NumberFormat('en-AU', { style: 'currency', currency: config.currency, maximumFractionDigits: 0 }).format(cents / 100);
    let scheduled = false;
    const options = { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] };
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; update(); });
    });
    const update = () => {
      observer.disconnect();
      const group = root.querySelector('#izyAddons');
      const matched = config.items.map(item => ({ item, row: group?.querySelector('[data-variant="' + item.variant + '"]') }));
      if (group && matched.every(entry => entry.row)) {
        group.dataset.blueLagoon = 'true';
        group.setAttribute('role', 'group');
        group.setAttribute('aria-labelledby', 'BlueLagoonAddonsHeading');
        group.setAttribute('aria-describedby', 'BlueLagoonAddonsHelp');
        if (!group.querySelector('.blue-lagoon-addons__intro')) {
          const content = template.content.cloneNode(true);
          group.prepend(content.querySelector('.blue-lagoon-addons__intro'));
          group.append(content.querySelector('.blue-lagoon-addons__summary'));
        }
        let total = config.base;
        let unavailable = false;
        matched.forEach(({ item, row }, index) => {
          const input = row.querySelector('input[type="checkbox"]');
          const title = row.querySelector('.addonTitle');
          const price = row.querySelector('.addonPrice');
          row.parentElement.append(row);
          input?.setAttribute('aria-label', item.name);
          if (title && title.textContent !== item.name) title.textContent = item.name;
          if (price) {
            const fragment = document.createDocumentFragment();
            if (item.compare) {
              fragment.append(config.was + ' ');
              const original = document.createElement('s');
              original.textContent = money(item.compare);
              fragment.append(original, ' — ' + config.now + ' +' + money(item.price) + ' ' + config.discount);
            } else {
              fragment.append('+' + money(item.price));
            }
            price.replaceChildren(fragment);
          }
          if (input?.checked) total += item.price;
          if (!input || input.disabled) unavailable = true;
        });
        group.querySelector('[data-package-total]').textContent = money(total) + ' ' + config.currency;
        group.querySelector('.blue-lagoon-addons__unavailable').hidden = !unavailable;
      }
      observer.observe(root, options);
    };
    root.addEventListener('change', event => {
      if (event.target.closest('#izyAddons')) update();
    });
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
  } catch(e) { console.error(e); }
})();

})();
